(function () {
  'use strict';

  var root = document.querySelector('[data-ldc-root]');
  if (!root || root.dataset.ldcReady === 'true') return;
  root.dataset.ldcReady = 'true';

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ldc-card]'));
  var editorial = root.querySelector('[data-ldc-editorial]');
  var count = root.querySelector('[data-ldc-count]');
  var empty = root.querySelector('[data-ldc-empty]');
  var shapeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ldc-shape]'));
  var styleButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ldc-style]'));
  var filterTrigger = root.querySelector('[data-ldc-filter-trigger]');
  var filterPanel = root.querySelector('[data-ldc-filter-panel]');
  var sort = root.querySelector('[data-ldc-sort]');
  var activeShape = 'all';
  var activeStyle = '';

  function orderShapeControls() {
    var counts = {};
    cards.forEach(function (card) {
      counts[card.dataset.shape] = (counts[card.dataset.shape] || 0) + 1;
    });

    [root.querySelector('.ldc__shapes'), filterPanel].forEach(function (container) {
      if (!container) return;
      var controls = Array.prototype.slice.call(container.querySelectorAll('[data-ldc-shape]:not([data-ldc-shape="all"])'));
      controls.sort(function (a, b) {
        if (a.dataset.ldcShape === 'round') return -1;
        if (b.dataset.ldcShape === 'round') return 1;
        var difference = (counts[b.dataset.ldcShape] || 0) - (counts[a.dataset.ldcShape] || 0);
        return difference || Number(a.dataset.ldcOrder) - Number(b.dataset.ldcOrder);
      });
      controls.forEach(function (control) {
        control.dataset.ldcCount = counts[control.dataset.ldcShape] || 0;
        container.appendChild(control);
      });
    });
  }

  function labelForNumber(value) {
    var template = value === 1 ? root.dataset.countOne : root.dataset.countMany;
    return (template || '{{ count }} rings').replace('{{ count }}', value);
  }

  function render() {
    var visible = 0;
    cards.forEach(function (card) {
      var shapeMatch = activeShape === 'all' || card.dataset.shape === activeShape;
      var styleMatch = !activeStyle || (' ' + card.dataset.style + ' ').indexOf(' ' + activeStyle + ' ') !== -1;
      card.hidden = !(shapeMatch && styleMatch);
      if (!card.hidden) visible += 1;
    });
    if (editorial) editorial.hidden = activeShape !== 'all' || activeStyle !== '';
    if (count) count.textContent = labelForNumber(visible);
    if (empty) empty.hidden = visible !== 0;
  }

  function setShape(value) {
    activeShape = value;
    shapeButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.ldcShape === value));
    });
    render();
  }

  shapeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var requestedShape = button.dataset.ldcShape;
      if (requestedShape !== 'all' && requestedShape === activeShape) requestedShape = 'all';
      activeStyle = '';
      styleButtons.forEach(function (item) {
        item.setAttribute('aria-pressed', 'false');
      });
      setShape(requestedShape);
      if (filterPanel && !filterPanel.hidden && button.closest('[data-ldc-filter-panel]')) {
        filterPanel.hidden = true;
        filterTrigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  styleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setShape('all');
      activeStyle = activeStyle === button.dataset.ldcStyle ? '' : button.dataset.ldcStyle;
      styleButtons.forEach(function (item) {
        item.setAttribute('aria-pressed', String(item.dataset.ldcStyle === activeStyle));
      });
      render();
    });
  });

  if (filterTrigger && filterPanel) {
    filterTrigger.addEventListener('click', function () {
      var willOpen = filterPanel.hidden;
      filterPanel.hidden = !willOpen;
      filterTrigger.setAttribute('aria-expanded', String(willOpen));
    });
  }

  if (sort) {
    sort.addEventListener('change', function () {
      var mode = sort.value;
      cards.sort(function (a, b) {
        if (mode === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        if (mode === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.manualOrder) - Number(b.dataset.manualOrder);
      });
      cards.forEach(function (card) {
        root.querySelector('[data-ldc-grid]').appendChild(card);
      });
      if (editorial && mode === 'manual') {
        var sixth = root.querySelector('[data-ldc-card][data-manual-order="6"]');
        if (sixth) sixth.insertAdjacentElement('afterend', editorial);
      } else if (editorial) {
        editorial.hidden = true;
      }
    });
  }

  orderShapeControls();
})();
